import { Box, useTheme } from '@mui/material';
import { ENV, STRINGS } from '../../constants';
import { formattedDayOfTheWeekDayMonthShipmentDate } from '../../utils/dateAndTime';
import {
  HomeCollection,
  LabelDropOff,
  LabelPack,
  LabelPrint,
  Receipt,
} from '../../components/icons';

const QrCodeIcon = ({ style }) => {
  const theme = useTheme();
  const darkSelector = theme.getColorSchemeSelector('dark');
  return (
    <Box
      sx={{ [darkSelector]: { filter: 'invert(1)' }, display: 'inline-flex' }}
    >
      <img
        src={`${ENV.CDN_BASE_URL_IMAGES}/qr.png`}
        alt='qrcode'
        style={{ padding: '5px', ...style }}
      />
    </Box>
  );
};

export const DROP_OFF_STEPS_CONFIG = [
  {
    id: 1,
    icon: LabelPrint,
    text: STRINGS.CONFIRMATION.STEPS.PACK_ITEM,
  },
  {
    id: 2,
    icon: LabelPack,
    text: STRINGS.CONFIRMATION.STEPS.PRINT_LABEL,
  },
  {
    id: 3,
    icon: LabelDropOff,
    text: STRINGS.CONFIRMATION.STEPS.BRING_PARCEL_TO_DROPOFF,
  },
];

export const DIGITAL_INFORMATION_STEPS_CONFIG = [
  {
    id: 1,
    icon: LabelPrint,
    text: STRINGS.CONFIRMATION.STEPS.TAKE_PARCEL_TO_PICKUP,
  },
  {
    id: 2,
    icon: QrCodeIcon,
    text: STRINGS.CONFIRMATION.STEPS.PRESENT_QR_CODE,
  },
  {
    id: 3,
    icon: LabelPack,
    text: STRINGS.CONFIRMATION.STEPS.ASSISTANT_SCAN,
  },
  {
    id: 4,
    icon: Receipt,
    text: STRINGS.CONFIRMATION.STEPS.RECEIVE_RECEIPT,
  },
];

export const COLLECTION_STEPS_CONFIG = (shipment, dropAtShop) => [
  {
    id: 1,
    icon: LabelPrint,
    text: STRINGS.CONFIRMATION.STEPS.PACK_ITEM,
  },
  {
    id: 2,
    icon: LabelPack,
    text: STRINGS.CONFIRMATION.STEPS.PRINT_LABEL,
  },
  {
    id: 3,
    icon: dropAtShop ? LabelDropOff : HomeCollection,
    text: dropAtShop ? (
      STRINGS.CONFIRMATION.STEPS.BRING_PARCEL_TO_DROPOFF
    ) : (
      <>
        {shipment?.shipmentDate &&
          formattedDayOfTheWeekDayMonthShipmentDate(shipment?.shipmentDate)}
        {shipment?.shipmentDate && <br />}
        {STRINGS.CONFIRMATION.STEPS.DRIVER_COLLECT}
      </>
    ),
  },
];
